import { defineSagaForService } from '@repo/core'
import { getUserInfo, getUserPreferences } from '@repo/user-services'
import { userInfoDataActions, userPreferencesDataActions } from '../../slices'

export const userInfoServiceConfig = defineSagaForService({
  [userInfoDataActions.getRequest.type]: {
    apiClientDomain: 'user',
    service: getUserInfo,
    actionTypeResponse: userInfoDataActions.getResponse.type,
    actionTypeRequest: userInfoDataActions.getRequest.type,
  },
  [userPreferencesDataActions.getRequest.type]: {
    apiClientDomain: 'user',
    service: getUserPreferences,
    actionTypeResponse: userPreferencesDataActions.getResponse.type,
    actionTypeRequest: userPreferencesDataActions.getRequest.type,
  },
  [userPreferencesDataActions.refreshRequest.type]: {
    apiClientDomain: 'user',
    service: getUserPreferences,
    actionTypeResponse: userPreferencesDataActions.refreshResponse.type,
    actionTypeRequest: userPreferencesDataActions.refreshRequest.type,
  },
})
